import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const STORAGE_KEY = "tlf_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, personalization = {}, quantity = 1) => {
    setItems((prev) => {
      // Each personalized item is a separate line
      return [
        ...prev,
        {
          line_id: `${product.id}-${Date.now()}`,
          product_id: product.id,
          name: product.name,
          price: product.price,
          image_url: product.image_url,
          size: product.size,
          quantity,
          personalization,
        },
      ];
    });
  };

  const removeItem = (line_id) =>
    setItems((prev) => prev.filter((i) => i.line_id !== line_id));

  const updateQty = (line_id, quantity) =>
    setItems((prev) =>
      prev.map((i) => (i.line_id === line_id ? { ...i, quantity: Math.max(1, quantity) } : i))
    );

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, addItem, removeItem, updateQty, clear, subtotal, count }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
